import { Squares2X2Icon } from "@heroicons/react/24/outline"
import CompositionTab from "./CompositionTab"

/**
 * Composition extension (admin side): an outfit / kit made of products the
 * store also sells on their own. The tab lists the parts (a product picker,
 * the label per language, qty, required, which of the part's options the
 * buyer picks and the values allowed), reorderable, and the pricing mode
 * with a live total. It writes the product's `components` and
 * `compositionPricing` through the form. The server half is
 * aldoo-na/store/product/extensions/composition; the storefront's part
 * blocks aldoo-ra/Store/extensions/composition/storefront.jsx.
 */
export const StoreProductExtension = {
  id: "composition",
  label: "Composition",
  description: "Outfits and kits: a product made of other products, the buyer picking the options of each part; priced as their sum, a fixed price, or the sum less a percent",
  icon: Squares2X2Icon,
  group: { id: "composition", label: "Composition", description: "The products this one is made of, and how it is priced." },
  section: {
    component: CompositionTab,
    label: "Composition",
    icon: Squares2X2Icon,
    order: 330,
  },
}
